import React from 'react';
import TreasuryOverviewSummary from './TreasuryOverviewSummary';
import TreasuryOverviewAccountsTable from './TreasuryOverviewAccountsTable';

const TreasuryOverview = () => {
    return (
        <div className=''>
            <h1 className='px-4 pt-[32px] lg:px-0 lg:pt-0 text-[20px] font-medium leading-[30px] text-ebony'>
                Overview
            </h1>

            <TreasuryOverviewSummary />

            <div className='mt-[32px] view-add-transactions'>
                <h1 className='px-4 py-5 lg:px-0 lg:pt-0 text-[20px] font-medium leading-[30px] text-ebony'>
                    Connected Accounts
                </h1>
                <TreasuryOverviewAccountsTable />
            </div>
        </div>
    );
};

export default TreasuryOverview;
